import { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { FormattedMessage, useIntl } from "react-intl";
import { useLocation } from "react-router-dom";

import { CreateNextPossibleStatusDTO } from '../../models/Status/CreateNextPossibleStatusDTO';
import { StatusService } from '../../services/StatusService';

import Toast from "../../helpers/Toast";

import { SelectItemsProps } from "../../components/Select2Component";
import SelectComponent from "../../components/SelectComponent";
import useValidationSchema, { FieldConfig } from "../../components/Validations";
import ButtonComponent from '../../components/ButtonComponent';
import InputComponent from "../../components/InputComponent";
import Layout from '../../components/Layout/Layout';
import PageTitle from '../../components/Layout/PageTitle';
import { CreateNewStatusDTO } from '../../models/Status/CreateNewStatusDTO';
import { PipeDTO } from '../../models/Pipe/PipeDTO';
import { on } from 'events';

type NextPossibleStatusProps = {
    BaseStatus: string;
    baseStatusName: string;
    onSuccess: () => void;
    onCancel: () => void;
}

export default function CreateNextPossibleStatus(props: NextPossibleStatusProps){
    const statusService = new StatusService();
    const [possibleStatus, setPossibleStatus] = useState<CreateNextPossibleStatusDTO>({} as CreateNextPossibleStatusDTO);
    const [status, setStatus] = useState<SelectItemsProps[]>([]);
    const [newStatus, setNewStatus] = useState<CreateNewStatusDTO>({} as CreateNewStatusDTO);

    const [loading, setLoading] = useState(false);

    const intl = useIntl();

    const getStatusByPipe = async () => {
    if (!props.BaseStatus) return;

    setLoading(true);

    const statusResponse = await statusService.GetStatusById(String(props.BaseStatus));
    if (!statusResponse.success || !statusResponse.obj) {
      Toast.Show("error", statusResponse.message ?? "Erro ao buscar estado base.");
      setLoading(false);
      return;
    }

    const baseStatus = statusResponse.obj;

    const response = await statusService.GetStatusByPipeId(baseStatus.idPipe.toString());

    if (!response.success || !response.obj) {
      Toast.Show("error", response.message ?? "Erro ao buscar estados por processo.");
      setLoading(false);
      return;
    }

    const filteredStatus: SelectItemsProps[] = response.obj.map((status: any) => ({
      value: status.name,
      label: status.name,
    }));

    setStatus(filteredStatus);
    setLoading(false);
  };

    useEffect(() => {
      getStatusByPipe();
    }, [props.BaseStatus]);

    const fields: FieldConfig[] = [
      ["baseStatusName", "string", "Screens.Status.Create.FirstStatusRequired"],
      ["nextStatusName", "string", "Screens.Status.Create.NextStatusRequired"]
    ]

    const schemaClientValidation = useValidationSchema(fields);

    //criar relação entre estados
    const CreatePossibleStatus = async () => {
        setLoading(true);

        const CreateNextStatus: CreateNextPossibleStatusDTO = {
          baseStatusId: Number(props.BaseStatus),
          nextStatusId: possibleStatus?.nextStatusId ?? null,
          baseStatusName: props.baseStatusName ?? null,
          nextStatusName: possibleStatus?.nextStatusName ?? null,
        };

        
        const { error } = schemaClientValidation.validate(CreateNextStatus);
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setLoading(false);
            return;
        }

        
        if (!possibleStatus.nextStatusName || !props.baseStatusName){
          setLoading(false);
          return;
        }

        //obter o id do segundo estado
        const nextStatus = await GetStatus((possibleStatus.nextStatusName).toUpperCase());

        if (!nextStatus) {
          setLoading(false);
          return;
        }

        CreateNextStatus.nextStatusId = nextStatus.id;

        var response = await statusService.CreateStatusRelation(CreateNextStatus);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setLoading(false);
            return;
          }
      
          Toast.Show("success", response.message);
          setLoading(false);
          props.onSuccess();
    }


    const GetStatus = async (name: string) => {
      setLoading(true);
      var response = await statusService.GetStatus(name);

      if (response.success === false) {
          Toast.Show("error", response.message);
          setLoading(false);
          return;
        }

        return response.obj;
  }

return(
    <>
          <Row style={{ marginTop: "15px" }}>
            <SelectComponent
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ width: "100%", height: "43px" }}
              label={intl.formatMessage({ id: "Screens.Status.Search.FirstStatus" })}
              selectedItemValue={props.baseStatusName}
              items={status}
              blockItem = {!!props.baseStatusName}
              onChange={(baseStatusName: string) => {
                setPossibleStatus({...possibleStatus!, baseStatusName: baseStatusName})
              }}
            />
            <SelectComponent
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ width: "100%", height: "43px" }}
              label={intl.formatMessage({ id: "Screens.Status.Search.SecondStatus" })}
              selectedItemValue={possibleStatus.nextStatusName}
              items={status}
              onChange={(nextStatusName: string) => {
                setPossibleStatus({...possibleStatus!, nextStatusName: nextStatusName})
              }}
            />
          </Row>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "25px" }}>
              <ButtonComponent
              text={intl.formatMessage({ id: "Common.Buttons.Cancel" })}
              onClick={() => props.onCancel()}
              style={{ minHeight: "37px", minWidth: "100px" }}
              />
              <ButtonComponent
              loading={loading}
              text={intl.formatMessage({ id: "Screens.Status.CreateRelation" })}
              onClick={() => CreatePossibleStatus()} 
              style={{ minWidth: "113px" }}
              />
            </div>
        </>
    );
}